import { writable } from 'svelte/store';

// Used only by TourFormMobile and TourGirVisibleDates as they are independent
// but VisibleDates triggers the modal from TourFormMobile to be opened
export const isModalOpen = writable(false);
export const modalExtraData = writable({});
